import { DatePipe } from '@angular/common';
import { Component, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DateFilters } from '../../interface/data.interface';

@Component({
  selector: 'app-filters-factoring',
  templateUrl: './filters-factoring.component.html',
  styleUrls: ['./filters-factoring.component.scss'],
  providers: [DatePipe],
})
export class FiltersFactoringComponent {
  @Output() onEnter: EventEmitter<DateFilters> = new EventEmitter();
  @Output() geFilter: EventEmitter<string> = new EventEmitter();
  @Output() siiFilter: EventEmitter<boolean | null> = new EventEmitter();
  @Output() pymeFilter: EventEmitter<boolean | null> = new EventEmitter();
  public formFilter!: FormGroup;
  public fechaDefaultMinBusqueda: Date = new Date('01-01-1900');

  constructor(private fb: FormBuilder) {
    this.formFilter = this.fb.group({
      start: [''],
      //end: [''],
      end: [this.fechaDefaultMinBusqueda],
      generalFilter: [''],
      //preference: [6],
      sii: ['all'],
      pyme: ['false'],
    });
  }

  ngOnInit(): void {}

  filtroGeneral(event: any) {
    const filterValue = event.target.value;
    this.geFilter.emit(filterValue);
    // this.invoicesFilter.emit(filterValue);
  }

  changePymeSelect() {
    let pymeBool: boolean;
    let selected: string = this.formFilter.controls['pyme']?.value;
    if (selected == 'true') {
      pymeBool = true;
    }
    if (selected == 'false') {
      pymeBool = false;
    }
    if (selected == 'nada') {
      pymeBool = null;
    }
    this.pymeFilter.emit(pymeBool);
  }

  changeSiiSelect(event: any) {
    let selected: string = this.formFilter.controls['sii']?.value;
    let sii: boolean | null;
    switch (selected) {
      case 'yes':
        sii = true;
        break;
      case 'no':
        sii = false;
        break;
      default:
        sii = null;
        break;
    }

    var datoInput = (document.getElementById("inputGeneral") as HTMLInputElement).value;
    this.siiFilter.emit(sii);
    this.geFilter.emit(datoInput);

  }

}
